/* Artist of Violence — theme interactions */
(function(){
  'use strict';
  // Mobile drawer
  var burger=document.getElementById('burger'),drawer=document.getElementById('drawer'),mask=document.getElementById('drawerMask');
  function closeDrawer(){drawer&&drawer.classList.remove('open');mask&&mask.classList.remove('open');burger&&burger.classList.remove('open');document.body.style.overflow='';}
  if(burger&&drawer){
    burger.addEventListener('click',function(){
      var open=drawer.classList.toggle('open');mask&&mask.classList.toggle('open',open);
      burger.classList.toggle('open',open);document.body.style.overflow=open?'hidden':'';
    });
    mask&&mask.addEventListener('click',closeDrawer);
    drawer.querySelectorAll('a,.close').forEach(function(el){el.addEventListener('click',closeDrawer);});
  }
  // Hide header on scroll down
  var head=document.querySelector('header.site'),last=0;
  addEventListener('scroll',function(){
    if(!head)return;var y=scrollY;
    head.style.transform=(y>last&&y>200)?'translateY(-100%)':'translateY(0)';last=y;
  },{passive:true});
  // Reveal on scroll (guarded)
  try{
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:.1});
      document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
    }else{document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');});}
  }catch(e){document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');});}
  // Accordions
  document.querySelectorAll('.acc-item').forEach(function(item){
    var h=item.querySelector('.acc-head'),b=item.querySelector('.acc-body');
    if(!h||!b)return;
    h.addEventListener('click',function(){
      var open=item.classList.toggle('open');
      b.style.maxHeight=open?(b.querySelector('.inner').scrollHeight+20)+'px':'0';
    });
  });
  // Set correct max-height for pre-opened accordions on load
  document.querySelectorAll('.acc-item.open').forEach(function(item){
    var b=item.querySelector('.acc-body');
    if(b){var inner=b.querySelector('.inner');if(inner)b.style.maxHeight=(inner.scrollHeight+20)+'px';}
  });
  // PDP thumbnail gallery
  var main=document.getElementById('pdpMain');
  if(main){
    document.querySelectorAll('.pdp-thumbs button').forEach(function(btn){
      btn.addEventListener('click',function(){
        document.querySelectorAll('.pdp-thumbs button').forEach(function(b){b.classList.remove('active');});
        btn.classList.add('active');
        var img=main.querySelector('img');if(img&&btn.dataset.full)img.src=btn.dataset.full;
      });
    });
  }
  // Disable checkout button on click to prevent double-submission
  var checkoutBtn=document.getElementById('checkout-btn');
  if(checkoutBtn){
    checkoutBtn.addEventListener('click',function(){
      setTimeout(function(){checkoutBtn.disabled=true;checkoutBtn.textContent='Processing…';},100);
    });
  }
  // Quantity steppers (PDP + cart) — floor respects input[min]
  document.querySelectorAll('.qty').forEach(function(q){
    var inp=q.querySelector('input');if(!inp)return;
    var m=q.querySelector('.minus'),p=q.querySelector('.plus');
    var cartForm=document.getElementById('cart-form');
    function submitCart(){if(cartForm){cartForm.submit();}}
    m&&m.addEventListener('click',function(){
      var min=parseInt(inp.getAttribute('min')||'0',10);
      var v=Math.max(min,(+inp.value||1)-1);inp.value=v;
      inp.dispatchEvent(new Event('change',{bubbles:true}));
      submitCart();
    });
    p&&p.addEventListener('click',function(){
      inp.value=(+inp.value||1)+1;
      inp.dispatchEvent(new Event('change',{bubbles:true}));
      submitCart();
    });
  });
  // Email popup — single system: 2-step (pitch → email), consent, success,
  // 8s-or-2nd-pageview trigger, 30-day dismiss + permanent subscribed
  // suppression, dismiss teaser, shared-overlay coordination, focus trap.
  var popup=document.getElementById('popupOverlay');
  if(popup){
    var DISMISS_COOKIE='aov_popup_dismiss';   // 30 days — set on close/skip/Esc/backdrop
    var SUBSCRIBED_COOKIE='aov_popup_subscribed'; // 365 days — set on success, never show again
    var VIEWS_KEY='aov_pageviews';

    function getCookie(n){
      var m=document.cookie.match(new RegExp('(?:^|; )'+n+'=([^;]*)'));
      return m?decodeURIComponent(m[1]):null;
    }
    function setCookie(n,val,days){
      var d=new Date();d.setTime(d.getTime()+days*86400000);
      document.cookie=n+'='+val+';expires='+d.toUTCString()+';path=/';
    }

    var box=document.getElementById('popupBox');
    var teaser=document.getElementById('popupTeaser');
    var isSuccess=!!popup.querySelector('[data-success]');
    var lastFocused=null;

    // ---- single shared "overlay open" flag, coordinated with the cart
    // drawer and Shopify's native consent/privacy banner, so this popup
    // never stacks on top of either. ----
    function cartDrawerOpen(){
      var cd=document.getElementById('aovCartDrawer');
      return !!(cd&&cd.classList.contains('open'));
    }
    function consentBannerOpen(){
      var b=document.getElementById('shopify-pc__banner')||document.querySelector('[id^="shopify-pc__banner"]');
      return !!(b&&b.offsetParent!==null);
    }
    function otherOverlayOpen(){return cartDrawerOpen()||consentBannerOpen();}

    function trapFocus(e){
      if(popup.style.display==='none'||e.key!=='Tab')return;
      var nodes=box.querySelectorAll('button:not([hidden]):not([disabled]), [href], input:not([hidden]), [tabindex]:not([tabindex="-1"])');
      var focusables=Array.prototype.filter.call(nodes,function(el){return el.offsetParent!==null;});
      if(!focusables.length)return;
      var first=focusables[0],last=focusables[focusables.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }

    function hideTeaser(){if(teaser)teaser.hidden=true;}
    function showTeaser(){
      if(!teaser||getCookie(SUBSCRIBED_COOKIE))return;
      teaser.hidden=false;
    }

    function showPopup(bypassSubscribedCheck){
      if(!bypassSubscribedCheck&&getCookie(SUBSCRIBED_COOKIE))return; // never show to subscribers
      if(!isSuccess&&otherOverlayOpen()){setTimeout(showPopup,500);return;} // wait for cart/consent banner to clear
      lastFocused=document.activeElement;
      popup.style.display='flex';
      document.body.classList.add('aov-overlay-open');
      document.body.style.overflow='hidden';
      document.addEventListener('keydown',trapFocus);
      hideTeaser();
      var heading=document.getElementById('popupHeading');
      if(heading){heading.setAttribute('tabindex','-1');setTimeout(function(){heading.focus();},10);}
    }
    function hidePopup(){
      popup.style.display='none';
      document.body.classList.remove('aov-overlay-open');
      document.body.style.overflow='';
      document.removeEventListener('keydown',trapFocus);
      if(lastFocused&&lastFocused.focus)lastFocused.focus();
    }
    function dismissPopup(){
      hidePopup();
      setCookie(DISMISS_COOKIE,'1',30);
      showTeaser();
    }

    if(isSuccess){
      showPopup(true); // bypass the subscribed-guard — this IS the one-time success screen that sets it
      setCookie(SUBSCRIBED_COOKIE,'1',365);
    } else {
      var excluded=/^\/cart|^\/checkout/.test(location.pathname);
      var views=parseInt(sessionStorage.getItem(VIEWS_KEY)||'0',10)+1;
      try{sessionStorage.setItem(VIEWS_KEY,String(views));}catch(e){}

      if(!getCookie(SUBSCRIBED_COOKIE)&&!getCookie(DISMISS_COOKIE)){
        if(!excluded){
          if(views>=2){showPopup();}
          else{setTimeout(showPopup,parseInt(popup.getAttribute('data-delay')||'8',10)*1000);}
        }
      } else if(getCookie(DISMISS_COOKIE)&&!getCookie(SUBSCRIBED_COOKIE)){
        showTeaser();
      }
    }

    var closeBtn=document.getElementById('popupClose');
    var skipBtn=document.getElementById('popupSkip');
    var step1NextBtn=document.getElementById('popupStep1Next');
    var backBtn=document.getElementById('popupBack');
    if(closeBtn)closeBtn.addEventListener('click',dismissPopup);
    if(skipBtn)skipBtn.addEventListener('click',dismissPopup);
    // Backdrop click intentionally does NOT close the popup — only the X (and Esc, for accessibility) do.
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&popup.style.display!=='none')dismissPopup();});
    if(teaser)teaser.addEventListener('click',function(){teaser.hidden=true;showPopup();});

    if(step1NextBtn)step1NextBtn.addEventListener('click',function(){
      var s1=popup.querySelector('[data-popup-step="1"]'),s2=popup.querySelector('[data-popup-step="2"]');
      if(box)box.setAttribute('data-step','2');
      if(s1)s1.hidden=true;
      if(s2){s2.hidden=false;var email=document.getElementById('popupEmail');if(email)email.focus();}
    });
    if(backBtn)backBtn.addEventListener('click',function(){
      var s1=popup.querySelector('[data-popup-step="1"]'),s2=popup.querySelector('[data-popup-step="2"]');
      if(box)box.setAttribute('data-step','1');
      if(s2)s2.hidden=true;
      if(s1){s1.hidden=false;var next=document.getElementById('popupStep1Next');if(next)next.focus();}
    });

    // Step aside (hide, no penalty) if the user opens the cart drawer while
    // the popup happens to be showing — mutual exclusion, not a stacked pair.
    var cdEl=document.getElementById('aovCartDrawer');
    if(cdEl&&window.MutationObserver){
      new MutationObserver(function(){
        if(cdEl.classList.contains('open')&&popup.style.display!=='none')hidePopup();
      }).observe(cdEl,{attributes:true,attributeFilter:['class']});
    }

    // Copy discount code to clipboard
    var copyBtn=document.getElementById('popupCopy');
    var codeEl=document.getElementById('popupCode');
    if(copyBtn&&codeEl){
      copyBtn.addEventListener('click',function(){
        var code=codeEl.textContent.trim();
        if(navigator.clipboard){
          navigator.clipboard.writeText(code).then(function(){copyBtn.textContent='Copied!';setTimeout(function(){copyBtn.textContent='Copy code';},2000);});
        } else {
          var ta=document.createElement('textarea');ta.value=code;document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);
          copyBtn.textContent='Copied!';setTimeout(function(){copyBtn.textContent='Copy code';},2000);
        }
      });
    }

    // Klaviyo: the native Shopify→Klaviyo customer sync creates a profile
    // but does NOT add it to the double opt-in "Email List" (verified: a
    // test signup synced with zero list memberships), so the Welcome Series
    // never triggers from that path alone. Subscribe directly via Klaviyo's
    // public Client API, once, at submit time (keepalive so the request
    // survives the form's full-page reload). company_id is this account's
    // real public_api_key (Klaviyo account API), not invented.
    var popupForm=document.getElementById('popup-form');
    if(popupForm&&!isSuccess){
      popupForm.addEventListener('submit',function(){
        var emailInput=document.getElementById('popupEmail');
        if(!emailInput||!emailInput.value)return; // submitting the form IS the marketing consent
        try{
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UTNmh2',{
            method:'POST',
            keepalive:true,
            headers:{'Content-Type':'application/json','revision':'2024-10-15'},
            body:JSON.stringify({
              data:{
                type:'subscription',
                attributes:{
                  custom_source:'AOV Popup',
                  profile:{data:{type:'profile',attributes:{email:emailInput.value}}}
                },
                relationships:{list:{data:{type:'list',id:'XHz55h'}}}
              }
            })
          });
        }catch(e){}
      });
    }
  }
  // Override Judge.me hiding preview badges on collection pages
  setTimeout(function(){
    var s=document.createElement('style');
    s.textContent='.jdgm-preview-badge{display:block!important}';
    document.head.appendChild(s);
  },800);

  // ── Cart Drawer ────────────────────────────────────────────────────────────
  var cdDrawer=document.getElementById('aovCartDrawer');
  var cdOverlay=document.getElementById('aovCartOverlay');
  var cdItems=document.getElementById('aovCdItems');
  var cdEmpty=document.getElementById('aovCdEmpty');
  var cdFooter=document.getElementById('aovCdFooter');
  var cdCount=document.getElementById('aovCdCount');
  var cdSubtotal=document.getElementById('aovCdSubtotal');
  var cdError=document.getElementById('aovCdError');

  function openCartDrawer(){
    if(!cdDrawer)return;
    cdDrawer.classList.add('open');
    if(cdOverlay)cdOverlay.classList.add('open');
    cdDrawer.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
  }
  function closeCartDrawer(){
    if(!cdDrawer)return;
    cdDrawer.classList.remove('open');
    if(cdOverlay)cdOverlay.classList.remove('open');
    cdDrawer.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
  }
  function moneyFmt(cents){return '$'+(cents/100).toFixed(2);}
  function showCartError(msg){
    if(!cdError)return;
    cdError.textContent=msg;
    cdError.style.display='block';
    setTimeout(function(){cdError.style.display='none';},5000);
  }
  function renderCartDrawer(cart){
    if(!cdDrawer)return;
    if(cdCount)cdCount.textContent=cart.item_count;
    var _badge=document.getElementById('aovCartBadge');
    if(_badge){_badge.textContent=cart.item_count;_badge.classList.toggle('aov-badge-zero',cart.item_count===0);}
    document.querySelectorAll('.aov-cart-link').forEach(function(el){el.textContent='Cart ('+cart.item_count+')';});
    if(cart.item_count===0){
      if(cdItems)cdItems.innerHTML='';
      if(cdEmpty)cdEmpty.style.display='flex';
      if(cdFooter)cdFooter.style.display='none';
    }else{
      if(cdEmpty)cdEmpty.style.display='none';
      if(cdFooter)cdFooter.style.display='block';
      if(cdSubtotal)cdSubtotal.textContent=moneyFmt(cart.total_price);
      if(cdItems)cdItems.innerHTML=cart.items.map(function(item){
        var img=item.image
          ?'<img class="aov-cd-item-img" src="'+item.image+'" alt="'+item.product_title.replace(/"/g,'&quot;')+'">'
          :'<div class="aov-cd-item-img"></div>';
        var variant=(item.variant_title&&item.variant_title!=='Default Title')
          ?'<div class="aov-cd-item-variant">'+item.variant_title+'</div>':'';
        return '<div class="aov-cd-item" data-key="'+item.key+'">'
          +img
          +'<div class="aov-cd-item-body">'
            +'<div class="aov-cd-item-title">'+item.product_title+'</div>'
            +variant
            +'<div class="aov-cd-item-bottom">'
              +'<div class="aov-cd-qty">'
                +'<button class="aov-cd-qty-btn" data-key="'+item.key+'" data-qty="'+(item.quantity-1)+'" aria-label="Decrease">−</button>'
                +'<span class="aov-cd-qty-num">'+item.quantity+'</span>'
                +'<button class="aov-cd-qty-btn" data-key="'+item.key+'" data-qty="'+(item.quantity+1)+'" aria-label="Increase">+</button>'
              +'</div>'
              +'<span class="aov-cd-item-price">'+moneyFmt(item.final_line_price)+'</span>'
              +'<button class="aov-cd-item-remove" data-key="'+item.key+'" aria-label="Remove item">&times;</button>'
            +'</div>'
          +'</div>'
        +'</div>';
      }).join('');
    }
  }
  function fetchAndRenderCart(){
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){renderCartDrawer(cart);return cart;});
  }
  window.AOVCart={open:openCartDrawer,close:closeCartDrawer,fetchAndRender:fetchAndRenderCart,showError:showCartError};

  var cdCloseBtn=document.getElementById('aovCdClose');
  if(cdCloseBtn)cdCloseBtn.addEventListener('click',closeCartDrawer);
  if(cdOverlay)cdOverlay.addEventListener('click',closeCartDrawer);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&cdDrawer&&cdDrawer.classList.contains('open'))closeCartDrawer();});

  // Qty steppers + remove buttons inside the drawer (delegated)
  if(cdDrawer){
    cdDrawer.addEventListener('click',function(e){
      var qb=e.target.closest('.aov-cd-qty-btn');
      var rb=e.target.closest('.aov-cd-item-remove');
      if(!qb&&!rb)return;
      var target=qb||rb;
      var itemKey=target.dataset.key;
      var newQty=qb?Math.max(0,parseInt(qb.dataset.qty,10)):0;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:itemKey,quantity:newQty})})
        .then(function(r){return r.json();})
        .then(renderCartDrawer)
        .catch(function(){showCartError(qb?'Could not update quantity.':'Could not remove item.');});
    });
  }

  // Quick-add pills — delegated, works on static + dynamic (search) cards
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('.aov-qa-pill');
    if(!btn||btn.disabled)return;
    e.preventDefault();e.stopPropagation();
    var id=parseInt(btn.dataset.variantId,10);
    if(!id)return;
    btn.disabled=true;
    btn.classList.add('loading');
    var orig=btn.textContent;
    btn.textContent='…';
    /* Open immediately rather than after the fetch/render chain resolves, same reasoning
       as the main PDP add-to-cart flow: don't let the drawer's visibility depend on that
       chain completing cleanly. */
    openCartDrawer();
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){
        if(!r.ok)return r.json().then(function(d){throw new Error(d.description||'Could not add to cart.');});
        return r.json();
      })
      .then(function(){
        btn.classList.remove('loading');btn.classList.add('added');btn.textContent='✓';
        return fetchAndRenderCart();
      })
      .then(function(){
        setTimeout(function(){btn.textContent=orig;btn.classList.remove('added');btn.disabled=false;},900);
      })
      .catch(function(err){
        btn.textContent=orig;btn.classList.remove('loading','added');btn.disabled=false;
        showCartError(err.message||'Could not add to cart. Please try again.');
      });
  });
})();
